export const diagnosticDetailsInitialValues = {
    date_of_diagnosis: null,
    primary_tumour_site: "",
    histology_morphology_description: "",
    icdo3_coding: "",
    secondary_tumour_site: "",
    metastasis_morphology: "",
    is_laterality: "",
    laterality: "",
    documents: [
        {
            document_name: "",
            documents: null,
            remarks: "",
        }
    ]
};

// Helper function to map API response to form values
export const mapDiagnosticDetailsResponse = (data) => {
    if (!data) return diagnosticDetailsInitialValues;

    return {
        date_of_diagnosis: data?.date_of_diagnosis
            ? data?.date_of_diagnosis.slice(0, 10)  // ensures YYYY-MM-DD
            : "",
        primary_tumour_site: data?.primary_tumour_site || "",
        histology_morphology_description: data?.histology_morphology_description || "",
        icdo3_coding: data?.icdo3_coding || "",
        secondary_tumour_site: data?.secondary_tumour_site || "",
        metastasis_morphology: data?.metastasis_morphology || "",
        is_laterality: data?.is_laterality !== null && data?.is_laterality !== undefined ? data?.is_laterality.toString() : "",
        laterality: data?.laterality || "",

        // Map documents from API or keep at least one empty row
        documents: data?.documents && data?.documents.length > 0
            ? data.documents.map(doc => ({
                document_name: doc?.document_name || "",
                documents: null, // File object will be set separately if needed
                remarks: doc?.remarks || "",
                existingFilePath: doc?.path || "", // Keep existing file path from server
                documentId: doc?.id || null, // Store document ID for updates
            }))
            : [
                {
                    document_name: "",
                    documents: null,
                    remarks: "",
                }
            ]
    };
};